import { Component, inject } from "@angular/core";
import { Announcements } from "@zixi/models";
import { AnnouncementsService } from "../../services/announcements.service";
import { CommonModule } from "@angular/common";
import { AnnouncementComponent } from "../shared/announcement/announcement.component";

@Component({
    selector: "app-critical-announcements",
    templateUrl: "./critical-announcements.component.html",
    imports: [CommonModule, AnnouncementComponent]
})
export class CriticalAnnouncementsComponent {
    private announcementsService = inject(AnnouncementsService);

    criticalAnnouncements$ = this.announcementsService.criticalAnnouncements$;

    dismiss(announcement: Announcements) {
        this.announcementsService.dismissCritical(announcement);
    }
}
